export const tutorialLink =
  "https://www.loom.com/embed/bc9be3f4a2094a7284c03897a97d13b1";
